import {
  GetCustomizeCar_customizeCar_availableFeatureCategories as FeatureCategory,
  GetCustomizeCar_customizeCar_availableFeatures as Feature,
} from '../graphql/queries/__generated__/GetCustomizeCar';
import IFeature from '../model/IFeature';
import availableFeatureService from './availableFeatureService';
import featureCategoryTypeService from './featureCategoryTypeService';
import ICategory from '../model/ICategory';
import ISection from '../model/ISection';

const availableFeaturesService = {
  getAvailableFeatures: (featureCategory: FeatureCategory, features: Feature[]): IFeature[] => {
    const processedFeatures: IFeature[] = [];
    features.forEach(feature => {
      if (featureCategory.code === feature.categoryCode) {
        processedFeatures.push(availableFeatureService.getFeature(feature));
      }
    });

    return processedFeatures;
  },

  getAvailableFeaturesCategories: (featureCategory: FeatureCategory, features: IFeature[]) => {
    const optionType = featureCategoryTypeService.getFeatureCategoryType(featureCategory.attributes.selectiontype);

    return {
      name: featureCategory.label,
      featuresList: {
        features,
        type: optionType,
      },
      attributes: featureCategory.attributes,
    };
  },

  getAvailableFeaturesOptionList: (featureCategory: FeatureCategory, features: IFeature[]) => {
    const optionType = featureCategoryTypeService.getFeatureCategoryType(featureCategory.attributes.selectiontype);

    return {
      features,
      type: optionType,
    };
  },

  getFeaturesTotalCount: (categories: ICategory[] | undefined): number => {
    if (!categories) return 0;

    return categories.reduce((total, category) => total + category.featuresList.features.length, 0);
  },

  getFeaturesCode: (features: IFeature[]): string[] => (features ? features.map(feature => feature.code) : []),

  getSelectedFeaturesCode: (selectedFeatures: ISection[]): string[] => {
    let featuresCode: string[] = [];
    selectedFeatures?.forEach(selectedFeature => {
      if (!selectedFeature.categories.length) {
        featuresCode = [
          ...featuresCode,
          ...availableFeaturesService.getFeaturesCode(selectedFeature.featuresList?.features),
        ];
      } else {
        selectedFeature.categories?.forEach(category => {
          featuresCode = [
            ...featuresCode,
            ...availableFeaturesService.getFeaturesCode(category.featuresList?.features),
          ];
        });
      }
    });

    return featuresCode;
  },
};

export default availableFeaturesService;
